import { createRoot } from 'react-dom/client';
import { unstable_HistoryRouter as HistoryRouter, Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider } from "@mui/material";
import { green, lightGreen } from '@mui/material/colors';
import { createBrowserHistory } from 'history';

import TransferPage from '~/pages/TransferPage';

import ProjectsPage from '~/pages/ProjectsPage';
import ProjectInvitationPage from '~/pages/ProjectInvitationPage';
import WalletInvitationPage from '~/pages/WalletInvitationPage';
import AdminProjectsPage from '~/pages/AdminProjectsPage';
import AdminUsersPage from '~/pages/AdminUsersPage';
import AdminServicesPage from '~/pages/AdminServicesPage';
import AdminTransactionsPage from '~/pages/AdminTransactionsPage';
import AdminReportsPage from '~/pages/AdminReportsPage';
import AdminGraphReportsPage from '~/pages/AdminGraphReportsPage';
import AdminBillingExportPage from '~/pages/AdminBillingExportPage';
import AdminCatalogsPage from '~/pages/AdminCatalogsPage';
import AdminApiUsersPage from "./pages/AdminApiUsersPage";
import AdminQuickCommentPage from "./pages/AdminQuickCommentPage";

import ProjectSettingsPage from '~/pages/ProjectSettingsPage';
import ProjectKeysPage from '~/pages/ProjectKeysPage';
import ProjectConsumptionHistoryPage from '~/pages/ProjectConsumptionHistoryPage';
import ProjectConsumptionDetailPage from '~/pages/ProjectConsumptionDetailPage';
import ProjectUsersPage from '~/pages/ProjectUsersPage';
import ProjectFinancialPage from '~/pages/ProjectFinancialPage';
import ProjectDashboardPage from '~/pages/ProjectDashboardPage';
import ProjectJournalPage from '~/pages/ProjectJournalPage';
import ProjectNotificationsPage from '~/pages/ProjectNotificationsPage';
import ProjectBusinessPage from '~/pages/ProjectBusinessPage';
import ProjectCatalogPage from '~/pages/ProjectCatalogPage';

import TestPage from "./pages/TestPage";

import InitLayout from "~/components/InitLayout";
import RootNavigation from "~/components/RootNavigation";
import { BASENAME_PATH, ROUTES, TRANSFER_VERSION } from "~/const";
import { sentryInit } from "~/utils/sentry";
import { loginInit } from '~/providers/user';
import { isLocalhost } from "./utils/utils";

import './index.less';

const localhost = isLocalhost();

loginInit();
!localhost && sentryInit();

const root = createRoot(document.getElementById('app'));
const myTheme = createTheme({
	palette: {
		primary: {
			main: green[500],
		},
		secondary: {
			main: lightGreen[100],
		},
	},
});

root.render(<ThemeProvider theme={myTheme}>
	<HistoryRouter history={createBrowserHistory({ window })} basename={BASENAME_PATH}>
		<Routes>
			{ !TRANSFER_VERSION && <Route element={ <InitLayout /> }>
				<Route path={ROUTES.CLIENT_PROJECT_SETTINGS.path} element={<ProjectSettingsPage />} />
				<Route path={ROUTES.CLIENT_PROJECT_KEYS.path} element={<ProjectKeysPage />} />
				<Route path={ROUTES.CLIENT_PROJECT_CONSUMPTION_HISTORY.path} element={<ProjectConsumptionHistoryPage />} />
				<Route path={ROUTES.CLIENT_PROJECT_CONSUMPTION_DETAIL.path} element={<ProjectConsumptionDetailPage />} />
				<Route path={ROUTES.CLIENT_PROJECT_USERS.path} element={<ProjectUsersPage />} />
				<Route path={ROUTES.CLIENT_PROJECT_FINANCIAL.path} element={<ProjectFinancialPage />} />
				<Route path={ROUTES.CLIENT_PROJECT_DASHBOARD.path} element={<ProjectDashboardPage />} />
				<Route path={ROUTES.CLIENT_PROJECT_CATALOG.path} element={<ProjectCatalogPage />} />
				<Route path={ROUTES.MY_PROJECTS.path} element={<ProjectsPage />} />
				<Route path={ROUTES.PROJECT_INVITATION.path} element={<ProjectInvitationPage />} />
				<Route path={ROUTES.WALLET_INVITATION.path} element={<WalletInvitationPage />} />
				<Route path={ROUTES.ADMIN_PROJECTS.path} element={<AdminProjectsPage />} />
				<Route path={ROUTES.ADMIN_USERS.path} element={<AdminUsersPage />} />
				<Route path={ROUTES.ADMIN_SERVICES.path} element={<AdminServicesPage />} />
				<Route path={ROUTES.ADMIN_TRANSACTIONS.path} element={<AdminTransactionsPage />} />
				<Route path={ROUTES.ADMIN_REPORTS.path} element={<AdminReportsPage />} />
				<Route path={ROUTES.ADMIN_GRAPH_REPORTS.path} element={<AdminGraphReportsPage />} />
				<Route path={ROUTES.ADMIN_BILLING_EXPORT.path} element={<AdminBillingExportPage />} />
				<Route path={ROUTES.ADMIN_CATALOGS.path} element={<AdminCatalogsPage />} />
				<Route path={ROUTES.ADMIN_API_USERS.path} element={<AdminApiUsersPage />} />
				<Route path={ROUTES.ADMIN_PROJECT_SETTINGS.path} element={<ProjectSettingsPage isInternal={true} />} />
				<Route path={ROUTES.ADMIN_PROJECT_KEYS.path} element={<ProjectKeysPage isInternal={true} />} />
				<Route path={ROUTES.ADMIN_PROJECT_CONSUMPTION_HISTORY.path} element={<ProjectConsumptionHistoryPage isInternal={true} />} />
				<Route path={ROUTES.ADMIN_PROJECT_CONSUMPTION_DETAIL.path} element={<ProjectConsumptionDetailPage isInternal={true} />} />
				<Route path={ROUTES.ADMIN_PROJECT_USERS.path} element={<ProjectUsersPage isInternal={true} />} />
				<Route path={ROUTES.ADMIN_PROJECT_FINANCIAL.path} element={<ProjectFinancialPage isInternal={true} />} />
				<Route path={ROUTES.ADMIN_PROJECT_DASHBOARD.path} element={<ProjectDashboardPage isInternal={true} />} />
				<Route path={ROUTES.ADMIN_PROJECT_JOURNAL.path} element={<ProjectJournalPage />} />
				<Route path={ROUTES.ADMIN_PROJECT_NOTIFICATIONS.path} element={<ProjectNotificationsPage />} />
				<Route path={ROUTES.ADMIN_PROJECT_BUSINESS.path} element={<ProjectBusinessPage />} />
				<Route path={ROUTES.ADMIN_PROJECT_CATALOG.path} element={<ProjectCatalogPage isInternal={true} />} />
				<Route path={ROUTES.ADMIN_QUICK_COMMENT.path} element={<AdminQuickCommentPage />} />
				{ localhost && <Route path={ROUTES.TEST.path} element={<TestPage />} /> }
				<Route path="*" element={<RootNavigation />} />
			</Route> }
			{ TRANSFER_VERSION && <Route element={ <InitLayout /> }>
				<Route path="*" element={<TransferPage />} />
			</Route> }
		</Routes>
	</HistoryRouter>
</ThemeProvider>);
